import { notification } from "antd";
import { NotificationProvider } from "@refinedev/core";
export const appNotificationProvider : NotificationProvider = {
    open: ({ message, description, type, ...rest }) => {
        // Only show success notifications, ignore errors
        //console.log("open", message, description, type, rest);
        /*if (type === "success") {
            notification.open({
                message,
                description,
                type,
                ...rest,
            });
        }*/
    },
    close: () => {
        notification.destroy();
    },
};